<template>
  <div v-if="!isLoading && auth.emailVerified">
    <div class="justify-center items-center">
      <LoadingIndicator />
    </div>
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog class="relative z-50 2xl:hidden" @close="sidebarOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0"
          enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
          leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-900/80"></div>
        </TransitionChild>

        <div class="fixed inset-0 flex">
          <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
            enter-from="-translate-x-full" enter-to="translate-x-0"
            leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
            leave-to="-translate-x-full">
            <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
              <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">

                </div>
              </TransitionChild>
              <!-- Sidebar component, swap this element with another sidebar if you like -->
              <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                <div class="flex h-16 shrink-0 items-center">
                  <EstatecomplyLogo />
                </div>
                <nav class="flex flex-1 flex-col">
                  <ul role="list" class="flex flex-1 flex-col gap-y-7">
                    <li>
                      <div class="text-xs/6 font-semibold text-gray-400">{{ $gettext("Espace de travail") }}</div>
                      <ul role="list" class="-mx-2 space-y-1">
                        <li v-for="item in navigation_block_1" :key="item.name">
                          <router-link v-if="item.available" :to=item.page
                            :class="[isActive(item) ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                            <component :is="item.icon"
                              :class="[isActive(item) ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'size-6 shrink-0']"
                              aria-hidden="true" />
                            <span>{{ item.name }}</span>
                          </router-link>
                          <span v-if="!item.available"
                            class="text-gray-400 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold">
                            <component :is="item.icon" class="text-gray-400 size-6 shrink-0" aria-hidden="true" />
                            <span>{{ item.name }}</span>
                            <SoonLabel :item="item" />
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <div class="text-xs/6 font-semibold text-gray-400">{{ $gettext("Compliance") }}</div>
                      <ul role="list" class="-mx-2 mt-2 space-y-1">
                        <li v-for="item in navigation_block_2" :key="item.name">
                          <router-link v-if="item.available" :to=item.page
                            :class="[isActive(item) ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                            <component :is="item.icon"
                              :class="[isActive(item) ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'size-6 shrink-0']"
                              aria-hidden="true" />
                            <span>{{ item.name }}</span>
                            <SoonLabel :item="item" />
                          </router-link>
                          <span v-if="!item.available"
                            class="text-gray-400 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold">
                            <component :is="item.icon" class="text-gray-400 size-6 shrink-0" aria-hidden="true" />
                            <span>{{ item.name }}</span>
                            <SoonLabel :item="item" />
                          </span>
                        </li>
                      </ul>
                    </li>
                    <ul class="mt-auto">
                      <li v-for="item in navigation_block_3" :key="item.name">
                        <router-link v-if="item.available" :to=item.page
                          :class="[isActive(item) ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                          <component :is="item.icon"
                            :class="[isActive(item) ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'size-6 shrink-0']"
                            aria-hidden="true" />
                          <span>{{ item.name }}</span>
                          <SoonLabel :item="item" />
                        </router-link>
                        <span v-if="!item.available"
                          class="text-gray-400 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold">
                          <component :is="item.icon" class="size-6 shrink-0" aria-hidden="true" />
                          <span>{{ item.name }}</span>
                          <SoonLabel :item="item" />
                        </span>
                      </li>
                      <li>
                        <FeedbackWidget :text="$gettext('Aide & Feedback')" icon="LifebuoyIcon" :email="user?.email"/>
                      </li>
                    </ul>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div class="hidden 2xl:fixed 2xl:inset-y-0 2xl:z-50 2xl:flex 2xl:w-72 2xl:flex-col">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
        <div class="flex h-16 shrink-0 items-center">
          <EstatecomplyLogo />
        </div>
        <nav class="flex flex-1 flex-col">
          <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li>
              <div class="text-xs/6 font-semibold text-gray-400">{{ $gettext("Espace de travail") }}</div>
              <ul role="list" class="-mx-2 space-y-1">
                <li v-for="item in navigation_block_1" :key="item.name">
                  <router-link v-if="item.available" :to=item.page
                    :class="[isActive(item) ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                    <component :is="item.icon"
                      :class="[isActive(item) ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'size-6 shrink-0']"
                      aria-hidden="true" />
                    <span>{{ item.name }}</span>
                    <SoonLabel :item="item" />
                  </router-link>
                  <span v-if="!item.available"
                    class="text-gray-400 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold">
                    <component :is="item.icon" class="size-6 shrink-0" aria-hidden="true" />
                    <span>{{ item.name }}</span>
                    <SoonLabel :item="item" />
                  </span>
                </li>
              </ul>
            </li>
            <li>
              <div class="text-xs/6 font-semibold text-gray-400">{{ $gettext("Compliance") }}</div>
              <ul role="list" class="-mx-2 mt-2 space-y-1">
                <li v-for="item in navigation_block_2" :key="item.name">
                  <router-link v-if="item.available" :to=item.page
                    :class="[isActive(item) ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                    <component :is="item.icon"
                      :class="[isActive(item) ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'size-6 shrink-0']"
                      aria-hidden="true" />
                    <span>{{ item.name }}</span>
                    <SoonLabel :item="item" />
                  </router-link>
                  <span v-if="!item.available"
                    class="text-gray-400 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold">
                    <component :is="item.icon" class="size-6 shrink-0" aria-hidden="true" />
                    <span>{{ item.name }}</span>
                    <SoonLabel :item="item" />
                  </span>
                </li>
              </ul>
            </li>
            <ul class="mt-auto">
              <li v-for="item in navigation_block_3" :key="item.name">
                <router-link v-if="item.available" :to=item.page
                  :class="[isActive(item) ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']">
                  <component :is="item.icon"
                    :class="[isActive(item) ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600', 'size-6 shrink-0']"
                    aria-hidden="true" />
                  <span>{{ item.name }}</span>
                  <SoonLabel :item="item" />
                </router-link>
                <span v-if="!item.available"
                  class="text-gray-400 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold">
                  <component :is="item.icon" class="size-6 shrink-0" aria-hidden="true" />
                  <span>{{ item.name }}</span>
                  <SoonLabel :item="item" />
                </span>
              </li>
              <li>
                <FeedbackWidget :text="$gettext('Aide & Feedback')" icon="LifebuoyIcon" :email="user?.email"/>
              </li>
            </ul>
          </ul>
        </nav>
      </div>
    </div>

    <div class="2xl:pl-72">
      <div
        class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
        <button type="button" class="-m-2.5 p-2.5 text-gray-700 2xl:hidden" @click="sidebarOpen = true">
          <span class="sr-only">{{ $gettext("Ouvrir le menu") }}</span>
          <Bars3Icon class="size-6" aria-hidden="true" />
        </button>

        <!-- Separator -->
        <div class="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true" />

        <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6 justify-end">
          <div class="flex items-center gap-x-4 lg:gap-x-6">

            <!-- Separator -->
            <div class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" aria-hidden="true" />

            <!-- Profile dropdown -->
            <Menu as="div" class="relative" v-if="user">
              <MenuButton class="-m-1.5 flex items-center p-1.5">
                <span class="sr-only">{{ $gettext("Ouvrir le menu") }}</span>
                <img class="size-8 rounded-full bg-gray-50" :src=user.picture alt="" />
                <span class="hidden lg:flex lg:items-center">
                  <span class="ml-4 text-sm/6 font-semibold text-gray-900" aria-hidden="true">{{ user.name }}</span>
                  <ChevronDownIcon class="ml-2 size-5 text-gray-400" aria-hidden="true" />
                </span>
              </MenuButton>
              <transition enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                  class="absolute right-0 z-10 mt-2.5 w-40 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                  <MenuItem>
                    <router-link to="/profile"
                      class="block px-3 py-1 text-sm/6 text-gray-900">{{
                      $gettext("Profil") }}</router-link>
                  </MenuItem>
                  <MenuItem>
                    <button @click="handleLogout"
                      class="block px-3 py-1 text-sm/6 text-gray-900">{{
                        $gettext("Déconnexion") }}</button>
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>
      <main class="py-10">
        <div class="px-4 sm:px-6 lg:px-8">
          <AlertHandler ref="alertHandler" />
          <RouterView />
        </div>
      </main>
    </div>
  </div>
  <div v-if="!isLoading && !auth.emailVerified" class="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center p-4">
    <EstatecomplyLogo class="w-96 h-auto mb-6" />
    <ExclamationTriangleIcon class="h-12 w-12 text-red-600 mb-4" />
    <h1 class="text-2xl font-bold text-gray-900 mb-2">
      {{ $gettext("Veuillez vérifier votre adresse e-mail") }}
    </h1>
    <p class="text-gray-700 max-w-md">
      {{ $gettext("Pour continuer à utiliser la plateforme, vous devez confirmer votre adresse e-mail. Vérifiez votre boîte de réception et suivez le lien de confirmation.") }}
    </p>
    <button
      @click="handleLogout"
      class="mt-6 px-6 py-2 bg-indigo-600 text-white font-semibold rounded hover:bg-indigo-700 transition"
    >
      {{ $gettext("S'identifier") }}
    </button>
  </div>
  <div v-else>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import {
  Bars3Icon,
  Cog6ToothIcon,
  DocumentTextIcon,
  FolderIcon,
  QuestionMarkCircleIcon,
  HomeIcon,
  UsersIcon,
  GlobeEuropeAfricaIcon,
  ExclamationTriangleIcon
} from "@heroicons/vue/24/outline";
import { ChevronDownIcon } from "@heroicons/vue/20/solid";
import { useAuth0 } from "@auth0/auth0-vue";
import EstatecomplyLogo from "@/components/assets/EstatecomplyLogo.vue";
import SoonLabel from "@/components/layout/SoonLabel.vue";
import { useGettext } from "vue3-gettext";
import AlertHandler from "./components/layout/AlertHandler.vue";
import { showLoadingIndicator } from "@/utils/loadingState.js";
import LoadingIndicator from "@/components/ui/LoadingIndicator.vue";
import { useAuthStore } from "@/stores/auth";
import FeedbackWidget from "./components/ui/FeedbackWidget.vue";

const auth = useAuthStore();

showLoadingIndicator.value = false;

const { $gettext } = useGettext();
const route = useRoute();
const { user, isLoading, logout, loginWithRedirect } = useAuth0();
const handleLogout = () =>
  logout({
    logoutParams: {
      returnTo: window.location.origin,
    }
  });

const navigation_block_1 = [
  { name: $gettext("Tableau de bord"), page: "/", icon: HomeIcon, available: true },
  { name: $gettext("Clients"), page: "/customers", icon: UsersIcon, available: true },
  { name: $gettext("Ventes"), page: "/sale-listing-agreements", icon: DocumentTextIcon, available: true },
  { name: $gettext("Locations"), page: "/rental-listing-agreements", icon: DocumentTextIcon, available: true }
];
const navigation_block_2 = [
  { name: $gettext("Risques Pays"), page: "/countries-risk", icon: GlobeEuropeAfricaIcon, available: true },
  { name: $gettext("Documents"), page: "/", icon: FolderIcon, available: false },
  { name: $gettext("FAQ"), page: "/faq", icon: QuestionMarkCircleIcon, available: true }
];

const navigation_block_3 = [
  { name: $gettext("Paramètres"), page: "/settings", icon: Cog6ToothIcon, available: true },
];

const isActive = (item) => {
  if (item.page === "/") {
    return route.path === item.page;
  } else {
    return route.path.startsWith(item.page);
  }
};

onMounted(() => {
  if (!auth) {
    loginWithRedirect();
  }
});

const sidebarOpen = ref(false);
</script>
